import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import {
  shouldFallbackToStoreApi,
  useCloudConnectSubscription,
} from 'src/api/queries';
import { CloudConnectSubscriptionPage } from 'src/apps/manageSubscription/app/pages/cloudConnect/CloudConnectSubscriptionPage';
import { SubscriptionPage } from 'src/apps/manageSubscription/app/pages/SubscriptionPage';
import { Spinner } from 'src/components';

import { Route as SubscriptionsRoute } from '../subscriptions';

const subscriptionsPlanSearchSchema = z.object({
  cancel_subscription: z.enum(['confirm', 'survey', 'confirmation']).optional(),
});

export const Route = createFileRoute('/_auth/_layout/subscriptions/plan')({
  validateSearch: zodValidator(subscriptionsPlanSearchSchema),
  component: () => <SubscriptionPlanRoute />,
});

const SubscriptionPlanRoute = () => {
  const { useStoreApi } = SubscriptionsRoute.useLoaderData();
  const cloudConnectSubscription = useCloudConnectSubscription({
    enabled: !useStoreApi,
  });

  if (useStoreApi) {
    return <SubscriptionPage />;
  }

  if (cloudConnectSubscription.isPending) {
    return <Spinner />;
  }

  const subscription = cloudConnectSubscription.data ?? null;

  if (shouldFallbackToStoreApi(subscription, cloudConnectSubscription.error)) {
    return <SubscriptionPage />;
  }

  if (cloudConnectSubscription.error) throw cloudConnectSubscription.error;

  return <CloudConnectSubscriptionPage subscription={subscription} />;
};
